import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Box, Grid } from "@material-ui/core";
import { client } from "../../service/ApolloClient/ApolloClient";
import { QUERY_USER } from "../../service/ApolloClient/ApolloQueries";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { withRouter } from "react-router";
import PersonAddForm from "../../components/Person/Add/PersonAddForm";
import PersonListAttachment from "./PersonListAttachment";
import Loading from "../../components/UI/Loading/Loading";
import PersonAmar from "./PersonAmar";
import DebitCreditRowDetail from "../../components/DebitCredit/RowDetail";

export const PERSON_SELECT_EDIT = "PERSON_SELECT_EDIT";
export const PERSON_SELECT_ATTACHMENT = "PERSON_SELECT_ATTACHMENT";
export const PERSON_SELECT_CHEQUE_CONTRACT = "PERSON_SELECT_CHEQUE_CONTRACT";
export const PERSON_SELECT_CAR_CONTRACT = "PERSON_SELECT_CAR_CONTRACT";

class PersonAdminEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: PERSON_SELECT_EDIT,
      keyDebit: Math.random(),
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.handleReloadDebit = this.handleReloadDebit.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  handleSelectPage = (page) => {
    this.setState({
      pageSelect: page,
    });
  };

  loadPage = () => {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_USER,
        variables: {
          id: parseInt(this.state.id),
        },
      })
      .then((res) => {
        let data = res.data.user;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };

  handleReloadDebit() {
    this.setState({
      keyDebit: Math.random(),
    });
  }

  render() {
    const { data, loading, pageSelect } = this.state;

    let componentSelect = <Loading />;

    if (pageSelect === PERSON_SELECT_EDIT && !loading) {
      componentSelect = (
        <Wrapper>
          <Grid item md={12}>
            <Box mt={2} md={2}>
              <PersonAddForm
                handleSelectPage={this.handleSelectPage}
                data={data}
                isAdmin={true}
                handleReloadDebit={(e) => {}}
                isEdit={true}
              />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <DebitCreditRowDetail user={data.id} />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <PersonAmar user={data.id} amar={data.cheque_amar} />
            </Box>
          </Grid>
        </Wrapper>
      );
    } else if (pageSelect === PERSON_SELECT_ATTACHMENT && !loading) {
      componentSelect = (
        <PersonListAttachment
          handleBack={() => {
            this.setState({
              pageSelect: PERSON_SELECT_EDIT,
            });
          }}
          user={data}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          title={"ویرایش کاربر"}
          items={[
            {
              title: "ویرایش کاربر ",
              to: "/person/list/",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(PersonAdminEditPage);
